<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="queueInfo" (ngSubmit)="handleSave()">
    <div class="agent-settings-edit" onsip-grid-placement-shelf>
      <div class="first-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 property-header">Ring Strategy</div>
          <mat-form-field appearance="outline" class="ring-strategy-form-field">
            <mat-select formControlName="ringStrategy">
              @for (strategy of ringStrategies; track strategy) {
              <mat-option [value]="strategy">
                {{ strategy }}
              </mat-option>
              }
            </mat-select>
            @if (queueInfo.controls.ringStrategy.value === 'Roundrobin memory') {
            <mat-hint
              >Remembers the last agent to answer a call and rings the one next in line</mat-hint
            >
            } @if (queueInfo.controls.ringStrategy.value === 'Random') {
            <mat-hint>Sends call to a random agent</mat-hint>
            } @if (queueInfo.controls.ringStrategy.value === 'Ring all') {
            <mat-hint>Rings all agents simultaneously</mat-hint>
            } @if (queueInfo.controls.ringStrategy.value === 'Least recent') {
            <mat-hint>Rings the agent who has waited the longest to answer a call</mat-hint>
            } @if (queueInfo.controls.ringStrategy.value === 'Fewest calls') {
            <mat-hint>Rings the agent who has received the fewest calls</mat-hint>
            }
          </mat-form-field>
        </section>
      </div>
      <div class="second-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 property-header">Ring duration</div>
          <div class="duration-grid">
            <mat-form-field appearance="outline" class="field-50-p duration-select">
              <mat-select formControlName="ringDuration">
                @for (duration of ringDurations; track duration) {
                <mat-option [value]="duration">
                  {{ duration }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="seconds-text">seconds</span>
          </div>
        </section>
        <section class="with-mat-form-field">
          <div class="mat-body-1 property-header">
            Connection delay
            <mat-icon
              [matTooltip]="
                'Gives agents time to accept and prepare for a call before connecting with the caller.'
              "
              matTooltipClass="onsip-tooltip-background"
              [matTooltipPosition]="'above'"
              >help_outline
            </mat-icon>
          </div>
          <div class="duration-grid">
            <mat-form-field appearance="outline" class="field-50-p duration-select">
              <mat-select formControlName="connectionDelay">
                @for (delay of connectionDelays; track delay) {
                <mat-option [value]="delay">
                  {{ delay }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="seconds-text">seconds</span>
          </div>
        </section>
      </div>
      <div class="third-column">
        <section class="announce-hold">
          <mat-checkbox color="primary" class="mat-body-1" formControlName="reportHoldTime">
            <mat-label>Announce caller hold time to agent</mat-label>
          </mat-checkbox>
        </section>
      </div>
      <div class="fourth-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 property-header post-call">Post call wrap up</div>
          <div class="duration-grid">
            <mat-form-field appearance="outline" class="field-50-p duration-select">
              <mat-select formControlName="wrapupTime">
                @for (time of wrapupTimes; track time) {
                <mat-option [value]="time">
                  {{ time }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="seconds-text">seconds</span>
          </div>
        </section>
      </div>
    </div>
    <div class="page-view-controls">
      <button mat-button color="primary" type="button" (click)="cancel()">Cancel</button>
      <button type="submit" mat-flat-button color="primary">Save changes</button>
    </div>
  </form>
</onsip-loading-container>
